import { isPromise } from "../../fn";

const recoverAndRestart = (operation, context, recover, restart, next, last) => {
	const recoveryResult = recover(context, operation, { client: restart, forward: next, last });
	const doRestart = newContext => restart(operation, newContext ?? context);
	return isPromise(recoveryResult) ? recoveryResult.then(doRestart) : doRestart(recoveryResult);
};

/**
 * Creates recovering decorator for GqlFetcher
 */
const recoveryMiddleware = (shouldBeRecovered, recover) => (next, restart, last) => (
	operation,
	context,
) =>
	next(operation, context).catch(err =>
		shouldBeRecovered(err, operation)
			? recoverAndRestart(operation, context, recover, restart, next, last)
			: Promise.reject(err),
	);

export default recoveryMiddleware;
